export default "__VITE_ASSET__vVzC_Jf___"